// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__48pXG","info":"PatientInfo_info__1CyOf"};